import { useState } from "react";
import { toast } from "sonner";
import { Download, Upload, Car } from "lucide-react";
import { GlassCard } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

export const AracAktarim = () => {
  const [busy, setBusy] = useState(false);
  const [s, setS] = useState(null);
  const indir = async () => {
    try {
      const { data } = await api.get("/aktarim-arac/sablon", { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data); a.download = "uyumlu-araclar.xlsx"; a.click(); URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const yukle = async (file) => {
    const fd = new FormData(); fd.append("dosya", file); setBusy(true);
    try {
      const { data } = await api.post("/aktarim-arac/yukle", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setS(data); toast.success(`${data.guncellenen} ürüne ${data.arac} araç yazıldı`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <GlassCard className="p-6 space-y-4" data-testid="arac-aktarim">
      <div className="flex items-center gap-2 font-medium"><Car className="w-4 h-4" />Ürünlerin takıldığı araçlar</div>
      <p className="text-xs text-muted-foreground">1) Şablonu indirin: tüm mamul ürünleriniz mevcut araçlarıyla listelenir (aracı olmayan ürün boş satırla gelir). 2) Her araç için bir satır doldurun: Marka zorunlu; Model, Yıl Başlangıç, Yıl Bitiş ve Motor isteğe bağlı. Aynı ürüne birden fazla araç için satırı kopyalayın. 3) Yükleyin. Dosyada yer alan ürünlerin araç listesi dosyadakilerle değiştirilir; tüm satırları boş bırakılan ürünlere dokunulmaz.</p>
      <div className="flex flex-wrap gap-3">
        <button onClick={indir} data-testid="arac-sablon" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm border border-white/10 hover:bg-white/10"><Download className="w-4 h-4" />Araç şablonunu indir</button>
        <label className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm grad-bg text-white cursor-pointer ${busy ? "opacity-50 pointer-events-none" : ""}`} data-testid="arac-dosya-label">
          <Upload className="w-4 h-4" />{busy ? "Yükleniyor…" : "Doldurulmuş dosyayı yükle"}
          <input type="file" accept=".xlsx,.xls,.csv" className="hidden" data-testid="arac-dosya" onChange={(e) => { const f = e.target.files?.[0]; if (f) yukle(f); e.target.value = ""; }} />
        </label>
      </div>
      {s && (
        <div className="rounded-xl bg-white/[0.04] p-4 text-sm space-y-1" data-testid="arac-sonuc">
          <div>{s.guncellenen} ürün güncellendi · {s.arac} araç · {s.atlanan} ürün atlandı{s.hatali ? ` · ${s.hatali} hatalı` : ""}</div>
          {s.hatalar?.map((h) => <div key={h.satir} className="text-xs text-red-300">Satır {h.satir}: {h.mesaj}</div>)}
        </div>
      )}
    </GlassCard>
  );
};
